/* eslint-disable */
import React, { useState, useEffect ,useCallback} from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import Login from './components/Login';
import Register from './components/Register';
import { authService } from './services/auth';
import './App.css';
import Navbar from './components/Navbar';
import StartScreen from './components/StartScreen';
import GameScreen from './components/GameScreen';
import ResultScreen from './components/ResultScreen';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

function App() {
  // Estados do jogo
  const [gameState, setGameState] = useState('start');
  const [gameLevel, setGameLevel] = useState('facil');
  const [gameScore, setGameScore] = useState(0);
  const [gameTime, setGameTime] = useState(0);
  const [wordCount, setWordCount] = useState(10);  
  const [currentWordList, setCurrentWordList] = useState([]); // Novo estado para armazenar wordList
  const [dataFromChild, setDataFromChild] = useState("");
  const [autoRec, setAutoRec] = useState(true);

  // Estados de autenticação
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showRegister, setShowRegister] = useState(false);

  // Verificar se há usuário logado ao carregar a aplicação
  useEffect(() => {
    const currentUser = authService.getCurrentUser();
    if (currentUser) {
      setUser(currentUser);
    }
  }, []);

  // Funções de autenticação
  const handleLogin = async (credentials) => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await authService.login(credentials);
      setUser(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRegister = async (userData) => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await authService.register(userData);
      setUser(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };


  const resetGame = useCallback(() => {
    setGameState('start');
    setGameLevel('facil');
    setGameScore(0);
    setGameTime(0);
   // setDataFromChild(null);
    setCurrentWordList([]);
    // Adicione outros estados que precisam ser resetados
  }, []);

  const handleLogout = () => {
    authService.logout();
    setUser(null);
    setGameState('start');
  };

  // Limpar tudo quando o componente for desmontado
  useEffect(() => {
    return () => {
      resetGame();
    };
  }, [resetGame]);
  
  // Funções do jogo
  const handleStartGame = useCallback((level, count, autoRec) => {
    resetGame();
    setGameLevel(level);
    setWordCount(count);
    setAutoRec(autoRec);
    setGameState('playing');
  }, [resetGame]);

console.log("Estado atual do App:", {
    gameState,
    gameLevel,
    gameScore,
    gameTime,
    currentWordList
  });
const handleGameOver = (score, timeElapsed, audioUrl, wordList) => {
    // Garantir que a wordList está no formato correto
    let processedWordList = [];
    if (Array.isArray(wordList)) {
        processedWordList = wordList.map(word => ({
            verbete: typeof word === 'string' ? word : String(word),
            level: gameLevel // usando o gameLevel do estado
        }));
    }

    console.log("handleGameOver - Dados processados:", {
        score,
        timeElapsed,
        audioUrl,
        processedWordList
    });

    setGameScore(score);
    setGameTime(timeElapsed);
    setGameState('result');
    setDataFromChild(audioUrl);
    setCurrentWordList(processedWordList);
};


  const handlePlayAgain = () => {
    setGameState('start');
    setCurrentWordList([]); // Limpar a lista ao jogar novamente
    resetGame();
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="min-h-screen">
        <Navbar 
          user={user}
          onLogin={() => setShowRegister(false)}
          onLogout={handleLogout}
        />
        <main className="main-content">
          {!user ? (
            showRegister ? (
              <Register
                onRegister={handleRegister}
                onSwitchToLogin={() => setShowRegister(false)}
                isLoading={isLoading}
                error={error}
              />
            ) : (
              <Login
                onLogin={handleLogin}
                onSwitchToRegister={() => setShowRegister(true)}
                isLoading={isLoading}
                error={error}
              />
            )
          ) : (
            <div className="app container">
              {gameState === 'start' && (
                <StartScreen onStartGame={handleStartGame} />
              )}

              {gameState === 'playing' && (
                <GameScreen
                  key={`game-${Date.now()}`} // Força recriação do componente
                  level={gameLevel}
                  wordCount={wordCount}
                  autoRec={autoRec}
                  onGameOver={handleGameOver}
                />
              )}

              {gameState === 'result' && (
                <ResultScreen
                  key={`result-${Date.now()}`} // Força recriação do componente
                  score={gameScore}
                  time={gameTime}
                  level={gameLevel}
                  AudioUrl={dataFromChild}
                  onPlayAgain={handlePlayAgain}
                  wordList={currentWordList} // Passando a lista salva
                />
              )}
            </div>
          )}
        </main>
      </div>
    </ThemeProvider>
  );
}

export default App;
